module.exports = __webpack_public_path__ + "assets/media/convo.e50da4b9.png";